import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  ChevronLeft,
  Plus,
} from 'react-bootstrap-icons';
import styles from './invoice_detail_view.module.css';
import { ActivityIcon, ActivityIconBlue, AIChatIcon2, AtollonIcon, EditIcon, FacebookIcon, GlobeIcon, LinkdinIcon, LockIcon, MessageIcon, MoreIcon, PhoneIcon, PrintIcon, SendIcon, ToolIcon, TrashIcon, TwitterIcon } from '../../../../components/protected/Icons/IconsLib';
import { ActionButton, Avatar, Cell, Column, Content, Dialog, DialogTrigger, Divider, Flex, Grid, Item, Link, Menu, MenuTrigger, Row, TableBody, TableHeader, TableView, TabList, TabPanels, Tabs, ToastQueue, View } from '@adobe/react-spectrum';
import moment from 'moment';
import { invokeFinderApp } from '../../../../utils/NavigationUtils';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { DeleteConfirmationDialog } from '../../finder/components/DeleteConfirmationDialog';
import { FPAData } from '../../../../infra/protected/FPA/FPAData';
import { useReefConfig } from '../../../../hooks/UseReefConfig';
import { getDownloadUrl } from '../../../../utils/ImagePathUtils';
import { useTranslation } from 'react-i18next';
import { statusColor } from '../../../../utils/helperUtil';
import { ListItemStatusRequest } from '../../../../services/soap/item/requests/ListItemStatusRequest';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Key } from '@react-types/shared';
import { Badge, Button } from 'react-bootstrap';
import { useCategoryColors } from '../../../../hooks/useCategoryColors';
import AddInvoiceDetail from './formSections/InvoiceDetailSection';
import AddSupplierDetail from './formSections/InvoiceSupplierSection';
import AddBankInfo from './formSections/InvoiceBankSection';
import InvoiceShippingSection from './formSections/InvoiceShippingSection';
import InvoiceFinanceSection from './formSections/InvoiceFinanceSection';
import InvoiceCustomAttributesSection from './formSections/InvoiceCustomAttributes';
import InvoiceCommentSection from './formSections/InvoiceCommentSection';
import TreeGridExample from '../../../examples/TreeGridExample';
import InvoiceCustomerSection from './formSections/InvoiceCustomerSection';
import { Invoice } from '../../../../services/soap/dataObjects/Invoice';
import InvoiceTransactionComponent from './formSections/InvoiceITransactionSection';
// import { ProductStatusDropdown } from './ProductStatusDropdown';
interface IInvoiceDetailViewProps {
  selectedInvoice: any;
  invoiceStatusList: any[];
  onPrint?: (item: any) => void;
  onEdit?: (item: boolean) => void;
  onDelete?: (item: any) => void;
  onTool?: (item: any) => void;
  onAI?: (item: any) => void;
  onCopy?: (item: any) => void;
  onMove?: (item: any) => void;
  selectedItem?: any;
  handleBackClick?: () => void;
  invoiceType?: any
}
const InvoiceDetailView: React.FC<IInvoiceDetailViewProps> = ({
  selectedInvoice,
  invoiceStatusList,
  onPrint, onEdit, onDelete, onTool, onAI, selectedItem, onCopy, onMove, handleBackClick, invoiceType
}) => {
  const { contactSettings } = usePreloadAssets();
  const [employeesData, setEmployeesData] = useState<any>([]);
  const { store, itemService } = useDependency();
  const [result, setResult] = useState<any>([]);
  let [invoice, setInvoice] = useState<any>();
  const { t } = useTranslation('invoice');
  const _t = (key: string) => t(`invoice_detail.${key}`, { ns: 'invoice' });
  const _tt = (key: string) => t(`invoice_common.${key}`, { ns: 'invoice' });
  const { getProductCategoryColor, getTextColor } = useCategoryColors();
  let [isOpen, setOpen] = React.useState(false);

  useEffect(() => {
    if (selectedInvoice) {
      setInvoice(selectedInvoice);
    }
  }, [selectedInvoice]);

  const { baseUrl, loginInfo } = useReefConfig();
  const getProfileUrl = () => {
    if (result.DOCUMENT && result.DOCUMENT.length > 0) {
      const imageUrl = getDownloadUrl(result.DOCUMENT[0].documentId, baseUrl, store.Server, store.SessionId);
      return imageUrl
    }
    return '/assets/images/avatar--desktop--light@2x.png'
  }


  function itemTemplate(data: any): JSX.Element {
    return (
      <Flex UNSAFE_className={styles.dot_text_container}>
        <View UNSAFE_className={styles.dot} UNSAFE_style={{ backgroundColor: `${data.color}` }}></View>
        <View marginTop={5}>{data.name}</View>
      </Flex>
    );
  }

  function valueTemplate(data: any): JSX.Element {
    return (
      <Flex UNSAFE_className={styles.dot_text_container}>
        <View UNSAFE_className={styles.dot} UNSAFE_style={{ backgroundColor: `${data.color}` }}></View>
        <View marginTop={5} UNSAFE_style={{ marginLeft: '10px' }}>
          <span title={data?.name}>{data?.name && data?.name.length > 16 ? data?.name.substring(0, 16) + '...' : data?.name}</span>
        </View>
      </Flex>
    );
  }

  async function updateActivityStatus(e: any) {
    console.log('Selected status:', e.value);
    // let resActivity = await projectService.updateActivity(new UpdateActivityRequest(store.Server, store.SessionId, { ...activityData, customState: e.value }));
    // let status = activityStatusList.find((status: any) => status.id === e.value);
    // if (resActivity.result == 'OK') {
    //   await featureService.checkWorkFlowQueue(new CheckWorkFlowQueueRequest(store.Server, store.SessionId));
    //   ToastQueue.positive(t('status_updated_successfully', { ns: 'layout_components' }), { timeout: 1000 });
    //   dispatch(setSelectedItem({ item: selectedItem ? { ...selectedItem, statusName: status.name, statusColor: statusColor(status.color) } : null, show_context: false }));
    // } else {
    //   ToastQueue.negative(resActivity.EXCEPTION?.message, { timeout: 1000 });
    // }
  }

  let menuItems = [
    { key: 'copy', name: _t('copy_link') },
    { key: 'move', name: _t('move') },
  ];

  const handlePrintClicked = () => {
    //console.log('handlePrintClicked');
    if (onPrint) {
      onPrint(invoice);
    }
  };

  const handleEditClicked = () => {
    console.log('handleEditClicked');
    if (onEdit) {
      onEdit(true);
    }
  };

  const handleDeleteClicked = () => {
    if (onDelete) {
      onDelete(invoice);
    }
  };

  const handleToolClicked = () => {
    console.log('handleToolClicked');
    if (onTool) {
      onTool(invoice);
    }
  };

  const handleAIClicked = () => {
    console.log('handleAIClicked');
    if (onAI) {
      onAI(invoice);
    }
  };

  const handleMenuClicked = (key: Key) => {
    if (key === 'copy') {
      copyUrl();
    } else if (key === 'move') {
      if (onMove) {
        onMove(invoice);
      }
    }
  };

  const copyUrl = () => {
    const url = `${window.location.origin}/products?id=${invoice?.id}`;
    navigator.clipboard.writeText(url);
    ToastQueue.positive(t('link_copied_to_clipboard', { ns: 'layout_components' }), { timeout: 1000 });
  }

  return (
    <Flex width="100%" direction={'column'}>
      <View UNSAFE_className={styles.header_main}>
        <View UNSAFE_className={styles.header_child}>
          <View UNSAFE_className={styles.frame_parent}>
            <View UNSAFE_className={styles.icon_activity_parent}>
              {handleBackClick &&
                <ActionButton isQuiet onPress={handleBackClick} UNSAFE_className={styles.back_button}>
                  <ChevronLeft size={20} />
                </ActionButton>
              }
              <ActivityIconBlue size={25} />
              <b title={invoice?.journalName} className={styles.activity_name}>
                {invoice?.journalName?.length > 55 ? invoice?.journalName.substring(0, 55) + '...' : invoice?.journalName}
              </b>
            </View>
            {(invoice?.folderName || invoice?.projectName || invoice?.ProjectName || invoice?.activityName) && (
              <View UNSAFE_className={styles.folder_name_parent}>
                <View UNSAFE_className={styles.folder_name}>
                  {invoice?.folderName && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(invoice.folder, 'folder')}
                    >
                      {invoice.folderName}
                    </Link>
                  )}

                  {invoice?.folderName && (invoice?.projectName || invoice?.ProjectName || invoice?.activityName) && (
                    <span> &gt; </span>
                  )}

                  {(invoice?.projectName || invoice?.ProjectName) && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(invoice.project, 'project')}
                    >
                      {invoice.projectName || invoice.ProjectName}
                    </Link>
                  )}

                  {(invoice?.projectName || invoice?.ProjectName) && invoice?.activityName && <span> &gt; </span>}

                  {invoice?.activityName && (
                    <Link
                      UNSAFE_className={styles.folder_name_link}
                      onPress={() => invokeFinderApp(invoice.activity, 'activity')}
                    >
                      {invoice.activityName}
                    </Link>
                  )}
                </View>
              </View>
            )}
          </View>
          {(invoice?.invoiceNumber || invoice?.created || invoice?.modified) &&
            <Flex direction={'row'} gap={'size-100'}>
              <View UNSAFE_className={styles.tag_parent} marginTop={'27px'}>
                {invoice?.invoiceNumber && (
                  <Content UNSAFE_style={{ fontSize: '14px' }}>
                    <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.footer_wrapper}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={invoice.invoiceNumber}>{_t('id')}</span>
                        </View>
                        <View position={'relative'} width={'2px'} height={'20px'} UNSAFE_className={styles.pipe_sign}></View>
                        <div className={styles.footer_text_1}>{invoice.invoiceNumber} </div>
                      </Flex>
                    </Flex>
                  </Content>
                )}
                {invoice?.created && (
                  <Flex direction={'column'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('created')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={invoice.created}>{moment(invoice.created).format('DD-MM-YYYY')}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                )}
                {invoice?.modified && (
                  <Flex direction={'column'}>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      {_t('modified')}
                    </Content>
                    <Content UNSAFE_style={{ fontSize: '14px' }}>
                      <Flex direction={'row'} alignItems={'center'} justifyContent={'center'} gap={'6px'}>
                        <View position={'relative'} UNSAFE_className={styles.footer_text_1}>
                          <span title={invoice.created}>{moment(invoice.modified).format('DD-MM-YYYY')}</span>
                        </View>
                      </Flex>
                    </Content>
                  </Flex>
                )}
              </View>
            </Flex>
          }
        </View>
        <View UNSAFE_className={styles.icon_list_parent}>
          {/* <ProductStatusDropdown productStatusArray={productStatusList} selectedStatus={product.status} onStatusChange={updateActivityStatus} /> */}
          <View UNSAFE_className={styles.icon_list_child}>
            <div className={styles.atollon_icon} onClick={handleAIClicked}>
              <AIChatIcon2 size={32} />
            </div>
            <div className={styles.edit_icon} onClick={handleEditClicked}>
              <EditIcon size={32} />
            </div>
            <div className={styles.tool_icon} onClick={handleToolClicked}>
              <LockIcon size={32} />
            </div>
            <div className={styles.delete_icon} onClick={handleDeleteClicked}>
              <TrashIcon size={32} />
            </div>
            <MenuTrigger>
              <ActionButton UNSAFE_style={{ border: 'none' }}>...</ActionButton>
              <Menu items={menuItems} onAction={handleMenuClicked}>
                {item => <Item key={item.key}>{item.name}</Item>}
              </Menu>
            </MenuTrigger>
          </View>
        </View>
      </View>
      <View height={'100vh'} width={'100%'}>
        <Tabs aria-label="invoice detail" isEmphasized>
          <TabList>
            <Item key="overview">{_t('overview')}</Item>
            <Item key="communication">{_t('communication')}</Item>
            <Item key="documents">{_t('documents')}</Item>
          </TabList>
          <TabPanels>
            <Item key="overview">
              <Flex direction={'row'} gap={'size-100'}>
                <AddInvoiceDetail isEdit={false} invoice={invoice} onChange={setInvoice} />
              </Flex>
              <Flex direction={'row'} gap={'size-100'}>
                <AddSupplierDetail invoice={invoice} isEdit={false} onChange={setInvoice} />
                <AddBankInfo invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex direction={'row'} gap={'size-100'}>
                <InvoiceCustomerSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                <InvoiceShippingSection invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex direction={'row'} gap={'size-100'}>
                <InvoiceFinanceSection invoice={invoice} isEdit={false} onChange={setInvoice} />
                <InvoiceCustomAttributesSection invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex>
                <InvoiceCommentSection invoice={invoice} isEdit={false} onChange={setInvoice} />
              </Flex>
              <Flex gap={'size-100'} marginTop={'size-100'} width={'100%'}>
                <InvoiceTransactionComponent invoice={invoice} isEdit={false} onInvoiceChange={setInvoice} />
              </Flex>
            </Item>
          </TabPanels>
        </Tabs>
      </View>
    </Flex>
  );
};

export default InvoiceDetailView;